import { MESSAGE_SUBSCRIBE_MENU_DATA } from '@/views/init-home/data/baseMenu'

/**
 * Status colors
 */
export const STATE_COLOR = {
    /** Stopped */
    'disabled': '#EB5757',
    /** Enabled */
    'enabled': '#00CCA5',
    /** Disabled */
    'notActive': '#F2994A',
    // Running
    'running': '#00CCA5',
    // Partial error
    'partialError': '#EB5757',
    // Error
    'failed': '#F2994A',
    // Stopped
    'stopped': '#F2994A'
}

/**
 * Card component status
 */
export const StatusColorEnum = {
  'success': 'success',
  'error': 'error',
  'processing': 'processing',
  'warning': 'warning',
  'default': 'default',
}

export const SystemConst = {
  API_BASE: 'api',
  SYSTEM_NAME: 'Jetlinks',
  LOGIN: 'LOGIN-STATUS',
  DOC_URL: 'http://doc.jetlinks.cn',
  BASE_CURD_MODAL_VISIBLE: 'BASE_CURD_MODAL_VISIBLE',
  BASE_CURD_CURRENT: 'BASE_CURD_CURRENT',
  BASE_CURD_MODEL: 'BASE_CURD_MODEL',
  BASE_UPDATE_DATA: 'BASE_UPDATE_DATA',
  GLOBAL_WEBSOCKET: 'GLOBAL-WEBSOCKET',
  BIND_USER_STATE: 'false',
  REFRESH_METADATA: 'refresh_metadata',
  REFRESH_METADATA_TABLE: 'refresh_metadata_table',
  GET_METADATA: 'get_metadata',
  REFRESH_DEVICE: 'refresh_device',
  VERSION_CODE: 'version_code',
  AMAP_KEY : 'amap_key',
}

export const USER_CENTER_MENU_CODE = 'account-center'
export const USER_CENTER_MENU_BUTTON_CODE = 'user-center-passwd-update'
export const MESSAGE_SUBSCRIBE_MENU_CODE = 'message-subscribe'
export const MESSAGE_SUBSCRIBE_MENU_BUTTON_CODE = 'message-subscribe-view'
